import React, { useEffect, useState } from 'react';
import { Phone, Check } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
export const FloatingElements = () => {
  const [showCartToast, setShowCartToast] = useState(false);
  const [price, setPrice] = useState(29.95);
  const [checkoutData, setCheckoutData] = useState<any>({
    qty: 1,
    activeBundle: null,
    selectedAddons: []
  });
  useEffect(() => {
    const handlePriceUpdate = (e: any) => {
      setPrice(e.detail.total);
      setCheckoutData(e.detail);
    };
    window.addEventListener('priceUpdate', handlePriceUpdate);
    return () => window.removeEventListener('priceUpdate', handlePriceUpdate);
  }, []);
  // Simulate a cart add for demonstration purposes
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowCartToast(true);
      setTimeout(() => setShowCartToast(false), 5000);
    }, 15000); // Show after 15s
    return () => clearTimeout(timer);
  }, []);
  return <>
      {/* Phone Button - Bottom Left */}
      <div className="fixed bottom-24 md:bottom-6 left-6 z-50 group" data-id="element-91">
        <a href="tel:+18000000000" className="flex items-center bg-patriot-navy border-2 border-acid-green/30 rounded-full h-14 shadow-[0_0_20px_rgba(200,255,0,0.15)] hover:border-acid-green transition-all overflow-hidden" data-id="element-92">
          <div className="w-14 h-14 flex items-center justify-center text-acid-green animate-pulse-slow" data-id="element-93">
            <Phone size={24} data-id="element-94" />
          </div>
          <div className="w-0 overflow-hidden group-hover:w-auto transition-all duration-300 ease-in-out" data-id="element-95">
            <span className="font-bebas text-xl text-white pr-6 whitespace-nowrap" data-id="element-96">
              +1 (800) 000-0000
            </span>
          </div>
        </a>
      </div>

      {/* Cart Notification Popup - Top Right */}
      <AnimatePresence data-id="element-97">
        {showCartToast && <motion.div initial={{
        opacity: 0,
        x: 50
      }} animate={{
        opacity: 1,
        x: 0
      }} exit={{
        opacity: 0,
        x: 50
      }} className="fixed top-24 right-6 z-50 bg-dark-1 border border-dark-3 border-l-4 border-l-acid-green p-4 shadow-2xl w-80" data-id="element-98">
            <div className="flex items-center gap-2 text-acid-green font-barlow font-bold text-xs tracking-widest uppercase mb-2" data-id="element-99">
              <Check size={14} data-id="element-100" /> ADDED TO ARSENAL
            </div>
            <div className="font-bebas text-lg text-white mb-4" data-id="element-101">
              BLACKOUT UNIT ULTIMATE MASK
            </div>
            <div className="flex gap-2" data-id="element-102">
              <button className="flex-1 bg-transparent border border-dark-3 text-text-body font-barlow text-xs tracking-wider py-2 hover:text-white hover:border-acid-green transition-colors" data-id="element-103">
                View Cart
              </button>
              <button onClick={() => setShowCartToast(false)} className="flex-1 bg-acid-green text-black font-barlow font-bold text-xs tracking-wider py-2 clip-diagonal hover:bg-white transition-colors" data-id="element-104">
                Continue
              </button>
            </div>
          </motion.div>}
      </AnimatePresence>

      {/* Mobile Sticky CTA */}
      <div className="fixed bottom-0 left-0 w-full bg-dark-1 border-t-2 border-acid-green p-3 z-40 md:hidden flex justify-between items-center shadow-[0_-10px_30px_rgba(0,0,0,0.8)]" data-id="element-105">
        <div className="flex flex-col" data-id="element-106">
          <span className="font-bebas text-2xl text-white leading-none" data-id="element-107">
            ${price.toFixed(2)}
          </span>
          <span className="font-barlow text-[10px] text-acid-green tracking-widest uppercase" data-id="element-108">
            FREE SHIPPING
          </span>
        </div>
        <button onClick={() => {
        if (checkoutData.cartUrl) {
          window.location.href = checkoutData.cartUrl;
        } else {
          alert('Lógica de carrito para esta combinación pendiente de links.');
        }
      }} className="bg-acid-green text-black font-barlow font-bold text-sm tracking-[2px] px-8 py-3 clip-diagonal active:bg-white" data-id="element-109">
          DEPLOY NOW
        </button>
      </div>
    </>;
};